<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <div
                    class="alert alert-danger"
                >O tamanho das imagens pode impactar diretamente na performance e tempo de carregamento do aplicativo.</div>
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-menu"></i> Operadora
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                              <div
                                  class="col-md-4"
                                  :class="{ 'dropdown-has-error': $v.model.id_pais.$error }"
                              >
                                  <label>País*</label>
                                  <select-api
                                      v-model="model.id_pais"
                                      :endpoint="'/pais/pesquisa'"
                                      :opt-text="'nome'"
                                      :select-option="true"
                                  ></select-api>
                              </div>

                              <div
                                  class="col-md-4"
                                  :class="{ 'dropdown-has-error': $v.model.id_integradora.$error }"
                              >
                                  <label>Integradora*</label>
                                  <select-api
                                      v-model="model.id_integradora"
                                      :endpoint="'/integradora/pesquisa'"
                                      :opt-text="'nome'"
                                      :select-option="true"
                                  ></select-api>
                              </div>
                            </div>
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Nome*</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="model.nome"
                                    />
                                </div>

                                <div
                                    class="col-md-3"
                                    :class="{ 'has-danger': $v.model.codigo.$error }"
                                >
                                    <label>Código*</label>
                                    <input
                                        type="text"
                                        maxlength="50"
                                        class="form-control"
                                        v-model="model.codigo"
                                    />
                                </div>

                                <div class="col-md-2">
                                    <label>Telefone SMS</label>
                                    <input
                                        type="text"
                                        maxlength="20"
                                        class="form-control"
                                        v-model="model.telefoneSms"
                                    />
                                </div>

                                <div class="col-md-3 align-self-center">
                                    <label>Ativo</label>
                                    <br />
                                    <input-toggle v-model="model.ativo" :value="model.ativo"></input-toggle>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-2">
                                    <label>Carrier</label>
                                    <input
                                        type="text"
                                        maxlength="20"
                                        class="form-control"
                                        v-model="model.carrier"
                                    />
                                </div>

                                <div class="col-md-3 col-xs-12"
                                  :class="{ 'dropdown-has-error': $v.model.tipoAutenticacao.$error }">
                                    <label>Tipo Autenticação*</label>
                                    <Select2
                                        placeholder="Selecione"
                                        v-model="model.tipoAutenticacao"
                                        :options="tiposAutenticacao"
                                    >
                                        <option value selected>Selecione</option>
                                    </Select2>
                                </div>

                                <div class="col-md-4 col-xs-12">
                                    <label>Campos obrigatórios</label>
                                    <Select2
                                        :multiple="true"
                                        v-model="model.camposRegistro"
                                        :options="camposObrigatorios"
                                        :is-array="true"
                                    >
                                    </Select2>
                                </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-md-3">
                                <label>Cor</label>
                                <chrome-picker v-model="corObjeto" />
                              </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-md-6">
                                <label>Mensagem Cancelamento</label>
                                <dw-textarea
                                    maxlength="250"
                                    v-model="model.mensagemCancelamento"
                                ></dw-textarea>
                              </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-md-6">
                                <label>Mensagem Número Cancelado</label>
                                <dw-textarea
                                    maxlength="250"
                                    v-model="model.mensagemNumeroCancelado"
                                ></dw-textarea>
                              </div>

                              <div class="col-md-6">
                                <label>Mensagem Número Inválido</label>
                                <dw-textarea
                                    maxlength="250"
                                    v-model="model.mensagemNumeroInvalido"
                                ></dw-textarea>
                              </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-md-6">
                                <label>Mensagem Não Assinante</label>
                                <dw-textarea
                                    maxlength="250"
                                    v-model="model.mensagemNaoAssinante"
                                ></dw-textarea>
                              </div>

                              <div class="col-md-6">
                                <label>Mensagem Sem Saldo</label>
                                <dw-textarea
                                    maxlength="250"
                                    v-model="model.mensagemSemSaldo"
                                ></dw-textarea>
                              </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-md-6">
                                <label>Url Verificação</label>
                                <dw-textarea
                                    maxlength="250"
                                    v-model="model.urlVerificacao"
                                ></dw-textarea>
                                <small>Pode colocar as tags {telefone} ou {codigo} para substituir pelo valor do usuário logado.</small>
                              </div>

                              <div class="col-md-6">
                                <label>Url Cancelamento</label>
                                <dw-textarea
                                    maxlength="250"
                                    v-model="model.urlCancelamento"
                                ></dw-textarea>
                                <small>Pode colocar as tags {telefone} ou {codigo} para substituir pelo valor do usuário logado.</small>
                              </div>
                            </div>

                            <div class="alert alert-warning">
                                <strong>Atenção!</strong>
                                O tamanho máximo e indicado para a
                                <strong>Imagem</strong> é de
                                <strong>300kb</strong>.
                            </div>
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <file-image
                                        v-model="imagem"
                                        :label="'Imagem'"
                                        :arquivo="model.arquivo"
                                    ></file-image>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-box"></i> Produtos
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div
                                    class="col-md-3"
                                    :class="{ 'has-danger': $v.produto.nome.$error }"
                                >
                                    <label>Nome*</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="produto.nome"
                                    />
                                </div>
                                <div class="col-md-3" :class="{ 'has-danger': $v.produto.codigoProduto.$error }">
                                    <label>Código Produto*</label>
                                    <input
                                        type="text"
                                        maxlength="20"
                                        class="form-control"
                                        v-model="produto.codigoProduto"
                                    />
                                </div>

                                <div class="col-md-3" :class="{ 'has-danger': $v.produto.codigoProdutoIntegradora.$error }">
                                    <label>Código Produto Integradora*</label>
                                    <input
                                        type="text"
                                        maxlength="20"
                                        class="form-control"
                                        v-model="produto.codigoProdutoIntegradora"
                                    />
                                </div>

                                <div class="col-md-2">
                                    <button
                                        type="button"
                                        @click="add"
                                        class="btn btn-primary"
                                        style="margin-top: 30px;"
                                    >Adicionar</button>
                                </div>
                            </div>

                            <div class="row mt-10" style="margin-top: 10px;">
                                <div class="col-md-12">
                                    <table class="table table-bordered table-striped table-md">
                                        <thead>
                                            <th>Cód.</th>
                                            <th>Nome</th>
                                            <th>Cód. Prod.</th>
                                            <th>Cód. Inte.</th>
                                            <th>Ações</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in model.produtos">
                                                <td>{{ item.id }}</td>
                                                <td :data-label="'Nome'">{{ item.nome }}</td>
                                                <td :data-label="'Cód. Prod.'">{{ item.codigoProduto }}</td>
                                                <td :data-label="'Cód. Inte.'">{{ item.codigoProdutoIntegradora }}</td>
                                                <td>
                                                    <button
                                                        class="btn btn-danger btn-sm"
                                                        type="button"
                                                        @click="remove(index)"
                                                    >
                                                        <i class="far fa-trash-alt"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                      <div class="card-footer text-right">
                          <router-link
                              :to="{ name: 'list-carrier' }"
                              class="btn btn-link"
                          >Cancelar</router-link>
                          <button type="submit" class="btn btn-primary">Salvar</button>
                      </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import Select from "../../components/Input/Select";
import SelectApi from "../../components/Input/SelectApi";
import FileImage from "../../components/Input/FileImage";
import { isPhone, isCpf, validateCPF } from "@/services/util";
import Collections from "../../helpers/collections";
import Select2 from '../../components/Input/Select2';
import { Chrome } from 'vue-color';
export default {
    components: {
        FileImage, Select2, SelectApi, Select, 'chrome-picker': Chrome
    },
    data() {
        return {
            model: {
                id: null,
                nome: "",
                telefoneSms: "",
                ativo: 0,
                arquivo: null,
                imagem: null,
                id_pais: '',
                id_integradora: '',
                tipoAutenticacao: '',
                cor: '',
                carrier: '',
                codigo: '',
                urlVerificacao: '',
                urlCancelamento: '',
                produtos: []
            },
            produto: {
              nome: '',
              codigoProduto: '',
              codigoProdutoIntegradora: ''
            },
            corObjeto: {},
            imagem: null,
            tiposAutenticacao: Collections.tipoAutenticacao,
            camposObrigatorios: Collections.camposObrigatorios
        };
    },
    validations() {
        let vm = this;

        return {
            model: {
                nome: {
                  required,
                  minLength: minLength(2)
                },
                codigo: {
                  required,
                  minLength: minLength(2),
                  maxLength: maxLength(50)
                },
                tipoAutenticacao: {
                  required
                },
                id_pais: {
                  required,
                  isNotUndefinedOrNullOrEmptyOrZero
                },
                id_integradora: {
                  required,
                  isNotUndefinedOrNullOrEmptyOrZero
                }
            },
            produto: {
              nome: {
                  required,
                  minLength: minLength(2)
              },
              codigoProduto: {
                  required,
                  minLength: minLength(2),
                  maxLength: maxLength(20)
              },
              codigoProdutoIntegradora: {
                  required,
                  minLength: minLength(2),
                  maxLength: maxLength(20)
              }
            }
        };
    },
    methods: {
        add() {
            let vm = this;
            if (this.$v.produto.$invalid) {
                this.$v.produto.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);

            vm.model.produtos.push(vm.produto);
            vm.clear();

            this.$loading.show(false);
        },
        clear() {
            this.produto = {
              nome: '',
              codigoProduto: '',
              codigoProdutoIntegradora: ''
            };
        },
        remove(index) {
          this.model.produtos.splice(index, 1);
        },
        async save() {
            let vm = this;
            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);

            try {
                vm.model.cor = vm.corObjeto.hex;

                const formData = new FormData();
                formData.append("data", JSON.stringify(vm.model));
                formData.append("imagem", vm.imagem);

                let ret = null;

                if (vm.model.id) {
                    ret = await facade.updateCarrier(formData, vm.model.id);
                    this.$router.push({ name: "list-carrier" });
                } else {
                    ret = await facade.createCarrier(formData);
                    vm.model.id = ret.data.data.id;
                    this.$router.push({
                        name: "list-carrier",
                        params: { id: vm.model.id }
                    });
                }

                this.$loading.show(false);
            } catch (e) {
                console.log(e);
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
                this.$loading.show(false);
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(model) {
            let vm = this;

            if (model !== undefined && model !== null) {
                vm.model = model;
                vm.corObjeto = vm.model.cor;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        let carrier = null;

        if (to.params.id) {
            carrier = (await facade.getCarrier(to.params.id)).data.data;
        }

        next(vm => vm.setData(carrier));
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?77ff1990